export default __webpack_public_path__ + "static/partner8-ba081f55a716ce4dd5f7b07bbf1277a6.jpg";